<a
    class="link-button {{ classList }}"
    [ngClass]="{ disabled: disable, 'disabled-with-tooltip': disable && tooltip.length }"
    href="#"
    (click)="onClick($event)"
    [ngbTooltip]="tooltip"
    [placement]="
        !!tooltipPlacement && innerWidth <= tooltipPlacement?.innerWidth
            ? tooltipPlacement?.placement
            : 'top'
    "
    [disableTooltip]="userAgentService.isOnMobileDevice && !tooltipPlacement?.placement"
>
    <app-icon *ngIf="icon" [type]="icon" class="link-button-icon"></app-icon>
    <ng-content></ng-content>
    <div
        class="link-button-label"
        [ngClass]="{
            'hidden-on-tablet': hideLabelOnTablet,
            'hidden-on-small-devices': hideLabelOnSmallDevices,
            'hidden-on-mobile': hideLabelOnMobile,
        }"
    >
        {{ label }}
    </div>
</a>
